import { FormEvent } from 'react';
import { OptionsFilterViewProps, OptionsType } from './AbstractFilterView';
import { AbstractToggleFilter } from './AbstractToggleFilter';
import { FilterEvent } from './FilterEvent';
import { InputType } from './Toggle/Item';

interface RadioFilterProps<VALUE_TYPE, OPTION_TYPE> extends OptionsFilterViewProps<VALUE_TYPE, OPTION_TYPE> {
}

export class RadioFilter<VALUE_TYPE extends string | number, OPTION_TYPE>
    extends AbstractToggleFilter<VALUE_TYPE, RadioFilterProps<VALUE_TYPE, OPTION_TYPE>, OPTION_TYPE> {
    protected getType(): InputType {
        return 'radio';
    }

    protected getOptions(): OptionsType<OPTION_TYPE> {
        return this.props.options;
    }

    protected handleInputChange(event: FormEvent<HTMLInputElement>) {
        const target = event.target as HTMLInputElement;
        const isChecked = target.checked;
        const value = target.value;

        const formEvent = new FilterEvent(event, isChecked ? value : undefined);
        this.handleChange(formEvent);
    }
}
